// extracted by mini-css-extract-plugin
export default {"privacy-policy-template":"styles_privacy-policy-template__MuavE"};